/**
 *    __________ ______ Copyright (C) Smart Software Factory SA de CV
 *   / ___/ ___// ____/ All Rights Reserved
 *   \__ \__ \ / /_     Unauthorized copying of this file,
 *  ___/ /__/ / __/     via any medium is strictly prohibited
 * /____/____/_/        Proprietary and confidential
 *
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getDayToDelete,
  getMonthToDelete,
  getYearToDelete,
  getDayToDeleteInvoice,
  getMonthToDeleteInvoice,
  getYearToDeleteInvoice,
  getSystemConfig,
  getSystemConfigInvoice,
  getSystemSettings,
  getSmtpSettings,
  testSmtpConfiguration,
  saveSmtpConfiguration,
  saveNewConfigurations,
} from './redux/actions';
import Form, { FormComponentProps } from 'antd/lib/form';
import { RootState } from 'store/configureStore';
import {
  Card,
  Col,
  Row,
  Spin,
  Switch,
  InputNumber,
  Button,
  Input,
  Modal,
  Slider,
  TimePicker,
  Select,
  Tag,
  Tooltip,
  Upload,
  notification,
  Collapse,
} from 'antd';
import './style.css';
import {
  SystemConfig,
  SystemConfigInvoice,
  Settings,
  SmtpSettings,
  SmtpTestResult,
} from 'types/type';
import moment from 'moment';
import { Popups } from 'commons/components/popups/popups';
import Text from 'antd/lib/typography/Text';

import {
  CheckCircleFilled,
  InfoCircleTwoTone,
  LockOutlined,
  UploadOutlined,
} from '@ant-design/icons';

import { getDecodeToken } from 'security';
import { Redirect } from 'react-router';
import { isEmpty } from 'lodash';
import { fileToBase64 } from 'commons/functions';

interface DispatchProps {
  getDayToDelete: () => void;
  getMonthToDelete: () => void;
  getYearToDelete: () => void;
  getDayToDeleteInvoice: () => void;
  getMonthToDeleteInvoice: () => void;
  getYearToDeleteInvoice: () => void;
  getSystemConfig: () => void;
  getSystemSettings: () => void;
  getSystemConfigInvoice: () => void;
  getSmtpSettings: () => void;
  saveNewConfigurations: (
    systemConfig: SystemConfig,
    systemConfigInvoice: SystemConfigInvoice,
    settings: Settings,
    days: number,
    months: number,
    years: number,
    daysInvoice: number,
    monthsInvoice: number,
    yearsInvoice: number,
  ) => void;
}

interface StateProps {
  isFetching: boolean;
  days: number;
  months: number;
  years: number;
  daysInvoice: number;
  monthsInvoice: number;
  yearsInvoice: number;
  systemConfig: SystemConfig;
  systemConfigInvoice: SystemConfigInvoice;
  settings: Settings;
  smtpSettings: SmtpSettings;
}

interface RangeToHour {
  range: number;
  value: number;
}

type Props = FormComponentProps & StateProps & DispatchProps;

const marks = {
  0: '-10 Hrs',
  10: '-9 Hrs',
  20: '-8 Hrs',
  30: '-7 Hrs',
  40: '-6 Hrs',
  50: '-5 Hrs',
  60: '-4 Hrs',
  70: '-3 Hrs',
  80: '-2 Hrs',
  90: '-1 Hr',
  100: {
    style: {
      color: 'red',
    },
    label: <strong>0 Hrs</strong>,
  },
};
const { Option } = Select;
const { Panel } = Collapse;

/**
 * El formulario SMTP es opcional: solo deja de serlo cuando el usuario captura algo.
 * Refleja SmtpSettings.hasData() del backend.
 */
const smtpHasData = (config: SmtpSettings): boolean =>
  [config.host, config.username, config.password, config.from].some(
    (value: string): boolean =>
      value !== undefined && value !== null && value.trim() !== '',
  ) || config.port !== null;

const conversion: RangeToHour[] = [
  { range: 0, value: 10 },
  { range: 10, value: 9 },
  { range: 20, value: 8 },
  { range: 30, value: 7 },
  { range: 40, value: 6 },
  { range: 50, value: 5 },
  { range: 60, value: 4 },
  { range: 70, value: 3 },
  { range: 80, value: 2 },
  { range: 90, value: 1 },
  { range: 100, value: 0 },
];
class Configuration extends Component<Props> {
  public state = {
    configModal: false,
    businessImageFile: new File([''], ''),
    businessLogoFile: new File([''], ''),
    smtpTesting: false,
    smtpTested: false,
    smtpDirty: false,
    smtpTestMessage: '',
  };

  public UNSAFE_componentWillMount(): void {
    this.chargeData();
  }

  public convertPeriodToHour = (value: number): number => {
    const result: RangeToHour | undefined = conversion.find(
      (itemrange: RangeToHour) => itemrange.range === value,
    );
    return result !== undefined ? result.value : 0;
  };
  public convertHourToPeriod = (value: string): number => {
    const result: RangeToHour | undefined = conversion.find(
      (itemrange: RangeToHour) => itemrange.value === Number(value),
    );
    return result !== undefined ? result.range : 0;
  };
  public getMaxOrMinBetweenHours(hourA: number, hourB: number, isMax: boolean) {
    if (hourA > hourB) {
      return isMax ? hourA : hourB;
    }
    return isMax ? hourB : hourA;
  }

  private async chargeData() {
    await this.props.getDayToDelete();
    await this.props.getMonthToDelete();
    await this.props.getYearToDelete();
    await this.props.getDayToDeleteInvoice();
    await this.props.getMonthToDeleteInvoice();
    await this.props.getYearToDeleteInvoice();
    await this.props.getSystemConfig();
    await this.props.getSystemConfigInvoice();
    await this.props.getSystemSettings();
    await this.props.getSmtpSettings();
  }

  private buildSmtpSettings = (values: {
    [field: string]: string | number | boolean | null;
  }): SmtpSettings => ({
    enabled: Boolean(values.smtpEnabled),
    host: ((values.smtpHost as string) || '').trim(),
    port:
      values.smtpPort === undefined || values.smtpPort === null
        ? null
        : Number(values.smtpPort),
    username: ((values.smtpUsername as string) || '').trim(),
    password: (values.smtpPassword as string) || '',
    from: ((values.smtpFrom as string) || '').trim(),
    auth: Boolean(values.smtpAuth),
    startTls: Boolean(values.smtpStartTls),
    sslEnable: Boolean(values.smtpSslEnable),
  });

  /**
   * Cualquier cambio invalida la prueba anterior: hay que volver a presionar Test.
   */
  private handleSmtpFieldChange = (): void => {
    this.setState({ smtpDirty: true, smtpTested: false, smtpTestMessage: '' });
  };

  private handleTestSmtp = async (): Promise<void> => {
    const values = this.props.form.getFieldsValue();
    const config: SmtpSettings = this.buildSmtpSettings(values);
    if (!smtpHasData(config)) {
      Popups.notifyError(
        'Captura los datos del servidor SMTP antes de ejecutar la prueba.',
      );
      return;
    }
    this.setState({ smtpTesting: true });
    const result: SmtpTestResult = await testSmtpConfiguration(
      config,
      (values.smtpTestRecipient as string) || '',
    );
    this.setState({
      smtpTesting: false,
      smtpTested: result.success,
      smtpTestMessage: result.message,
    });
    if (result.success) {
      Popups.notifySuccess(result.message);
    } else if (result.message !== '') {
      Popups.notifyError(result.message);
    }
  };

  private buildPrivacyUrl = (urlValue: string, preUrlValue: string): string => {
    if (urlValue === '#' || urlValue === '') {
      return '#';
    }
    return preUrlValue.concat(urlValue);
  };

  private handleOnSubmitModal = (): void => {
    const isG4sSalesOrigin = this.props.systemConfig.isG4sSalesOrigin;
    this.props.form.validateFieldsAndScroll(
      async (err, values): Promise<void> => {
        console.log(values);
        const systemConfig: SystemConfig = {
          id: 1,
          genericPublicCode: isG4sSalesOrigin ? values.genericPublicCode : '',
          autoInvoice: values.autoInvoice,
          syncSales: values.syncSales,
          g4sPaginationSize: values.g4sPaginationSize,
          syncCuts: values.syncCuts,
          g4sCutsSize: values.g4sCutsSize,
          minTotal: values.minTotal,
          userRegister: values.userRegister,
          changePayment: values.changePayment,
          changePaymentMethod: values.changePaymentMethod,
          paymentCodes: isG4sSalesOrigin ? values.paymentCodes : '',
          invoiceCredit: values.invoiceCredit,
          maxConceptsNumber: values.maxConceptsNumber,
          isPermissionCreFromSale: values.isPermissionCreFromSale,
          isG4sSalesOrigin: values.isG4sSalesOrigin,
          deadlineDaysForImportingSales: values.deadlineDaysForImportingSales,
          changeCustomer: values.changeCustomer,
          changeCut: values.changeCut,
          showCredit: values.showCredit,
          allowMultiple: values.allowMultiple,
          allowGlobal: values.allowGlobal,
          costeoMargin: !isG4sSalesOrigin ? values.costeoMargin : 0,
          forceMaxAmountGlobalInvoice: values.forceMaxAmountGlobalInvoice,
          businessImageBase64: await fileToBase64(this.state.businessImageFile),
          businessLogoBase64: await fileToBase64(this.state.businessLogoFile),
        };
        const systemConfigInvoice: SystemConfigInvoice = {
          id: 1,
          maxZipTimeHours: moment(values.maxZipTime).hours(),
          maxZipTimeMinutes: moment(values.maxZipTime).minutes(),
          maxZipSize: values.maxZipSize,
          rfcEmailReject: values.rfcEmailReject,
          emailContact: values.emailContact,
          siteContact: values.siteContact,
          satStsUpdIntervalMinutes: values.satStsUpdIntervalMinutes,
          satStsUpdFetchRangeDays: values.satStsUpdFetchRangeDays,
          satStsUpdMinDaysBefore: values.satStsUpdMinDaysBefore,
          issueDateFromSale: values.issueDateFromSale,
        };
        const settings: Settings = {
          timeOutCron: values.cronTimeout,
          timeOutLapse: this.getMaxOrMinBetweenHours(
            this.convertPeriodToHour(values.timeoutPeriod[0]),
            this.convertPeriodToHour(values.timeoutPeriod[1]),
            true,
          ).toString(),
          timeOutSince: this.getMaxOrMinBetweenHours(
            this.convertPeriodToHour(values.timeoutPeriod[0]),
            this.convertPeriodToHour(values.timeoutPeriod[1]),
            false,
          ).toString(),
          privacityUrl: this.buildPrivacyUrl(
            values.privacityUrl,
            values.preUrl,
          ),
          useG4scredentials: values.useG4scredentials,
          g4sPassword: values.g4sPassword,
          g4sUser: values.g4sUser,
          assignPaymentCode: values.assignPaymentCode,
          useCFDIS: values.useCFDIS,
        };
        if (err !== null) {
          Object.keys(err).forEach((key: any) => {
            Popups.notifyError('Error ' + err[key].errors[0].message);
          });
        } else {
          // La configuración SMTP solo se toca cuando el usuario la modificó, y
          // no puede guardarse sin haber pasado el botón Test.
          if (this.state.smtpDirty) {
            const smtpConfig: SmtpSettings = this.buildSmtpSettings(values);
            // Deshabilitada no se usa para enviar, por eso no se exige la prueba.
            if (
              smtpConfig.enabled &&
              smtpHasData(smtpConfig) &&
              !this.state.smtpTested
            ) {
              Popups.notifyError(
                'Ejecuta la prueba del servidor SMTP con el botón Test antes de guardar la configuración.',
              );
              return;
            }
            const smtpSaved: boolean = await saveSmtpConfiguration(
              smtpConfig,
              values.smtpTestRecipient || '',
            );
            if (!smtpSaved) {
              return;
            }
            this.setState({ smtpDirty: false });
          }
          this.props.saveNewConfigurations(
            systemConfig,
            systemConfigInvoice,
            settings,
            values.days,
            values.months,
            values.years,
            values.daysInvoice,
            values.monthsInvoice,
            values.yearsInvoice,
          );
        }
      },
    );
  };

  public handleBeforeUploadBusinessImage = (file: File): boolean => {
    if (file.size > 1000000)
      notification.warning({
        message: 'La imagen de la empresa es muy grande',
        description:
          'Se recomienda un tamaño de 2MB maximo un tamaño superior puede causar lentitud en el sistema',
        duration: 0,
      });
    this.setState({ businessImageFile: file });
    return false;
  };

  private handleRemoveBusinessImage = (): void => {
    this.setState({ businessImageFile: new File([''], '') });
  };

  public handleBeforeUploadBusinessLogo = (file: File): boolean => {
    if (file.size > 1000000)
      notification.warning({
        message: 'El logo de la empresa es muy grande',
        description:
          'Se recomienda un tamaño de 2MB maximo un tamaño superior puede causar lentitud en el sistema',
        duration: 0,
      });
    this.setState({ businessLogoFile: file });
    return false;
  };
  private handleRemoveBusinessLogo = (): void => {
    this.setState({ businessLogoFile: new File([''], '') });
  };

  public uploadButton = (text: string): JSX.Element => (
    <div>
      <Button size="large" style={{ color: '#2E76D1', borderColor: '#2E76D1' }}>
        <UploadOutlined /> {text}
      </Button>
    </div>
  );

  public render = (): JSX.Element => {
    if (getDecodeToken().isClient) {
      return <Redirect to="/home" />;
    }
    const {
      isFetching,
      days,
      months,
      years,
      daysInvoice,
      monthsInvoice,
      yearsInvoice,
      systemConfig,
      systemConfigInvoice,
      settings,
      smtpSettings,
      form,
    } = this.props;
    const { getFieldDecorator } = form;
    const selectBefore = (
      <Form.Item className="privacy">
        {getFieldDecorator('preUrl', {
          initialValue: 'http://',
        })(
          <Select>
            <Option value="http://">http://</Option>
            <Option value="https://">https://</Option>
          </Select>,
        )}
      </Form.Item>
    );
    return (
      <Spin tip="Cargando..." spinning={isFetching}>
        <Card>
          <Form>
            <Modal
              title={'Guardar configuraciones del sistema'}
              visible={this.state.configModal}
              width={window.innerWidth < 768 ? '95%' : '60%'}
              style={{ paddingTop: '0px' }}
              closable={false}
              cancelButtonProps={{ hidden: true }}
              okButtonProps={{ hidden: true }}
            >
              <Row>
                <p>
                  Estas configuraciones{' '}
                  <Text style={{ color: 'red' }}>
                    modifican el comportamiento del sistema
                  </Text>{' '}
                  si estas seguro de querer modificarlas presiona aceptar
                </p>
                <p>
                  Si quieres revisarlas antes de modificarlas presiona cancelar
                </p>
              </Row>
              <Row gutter={[10, 10]}>
                <Col xs={24} sm={{ span: 9, offset: 3 }}>
                  <Button
                    className="button-customer-serch-style"
                    type="primary"
                    onClick={() => {
                      this.setState({ configModal: !this.state.configModal });
                      this.handleOnSubmitModal();
                    }}
                  >
                    Aceptar
                  </Button>
                </Col>
                <Col xs={24} sm={{ span: 7, offset: 5 }}>
                  <Button
                    type="danger"
                    onClick={() => {
                      this.setState({ configModal: false });
                    }}
                  >
                    Cancelar
                  </Button>
                </Col>
              </Row>
            </Modal>
            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>
                    Configuración de importación ventas y cortes
                  </h2>
                </Col>
                <Col span={14}>
                  <Row>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item label="Origen de las ventas">
                        <Tag color="#296FC4">
                          Plataforma{' '}
                          {systemConfig.isG4sSalesOrigin
                            ? 'G4S'
                            : 'Liquidaciones'}
                        </Tag>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Activar sincronización de ventas">
                      {getFieldDecorator('syncSales', {
                        initialValue: systemConfig.syncSales,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item hasFeedback label="Ventas por minuto">
                      {getFieldDecorator('g4sPaginationSize', {
                        initialValue: systemConfig.g4sPaginationSize,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un minimo de ventas',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value < 0) {
                                callback('El valor no puede ser negativo');
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(<InputNumber size="large" placeholder="Ventas" />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Activar sincronización de cortes">
                      {getFieldDecorator('syncCuts', {
                        initialValue: systemConfig.syncCuts,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item hasFeedback label="Cortes por minuto">
                      {getFieldDecorator('g4sCutsSize', {
                        initialValue: systemConfig.g4sCutsSize,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un minimo de cortes',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value < 0) {
                                callback('El valor no puede ser negativo');
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(<InputNumber size="large" placeholder="Cortes" />)}
                    </Form.Item>
                  </Col>
                  {systemConfig.isG4sSalesOrigin && (
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item
                        hasFeedback
                        label="Código cliente en ventas con código erróneo"
                      >
                        {getFieldDecorator('genericPublicCode', {
                          initialValue: systemConfig.genericPublicCode,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa un codigo valido en G4S',
                            },
                          ],
                        })(<Input size="large" placeholder="Codigo cliente" />)}
                      </Form.Item>
                    </Col>
                  )}
                  {systemConfig.isG4sSalesOrigin && (
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item
                        help="Codigos separados por coma"
                        hasFeedback
                        label="Códigos de ventas internas"
                      >
                        {getFieldDecorator('paymentCodes', {
                          initialValue: systemConfig.paymentCodes,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa los codigos de pago',
                            },
                          ],
                        })(<Input size="large" placeholder="Codigos" />)}
                      </Form.Item>
                    </Col>
                  )}
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      hasFeedback
                      label="No importar ventas con total menor a"
                    >
                      {getFieldDecorator('minTotal', {
                        initialValue: systemConfig.minTotal,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un minimo de precio',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value < 0) {
                                callback('El total no puede ser negativo');
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(<InputNumber size="large" placeholder="Total" />)}
                    </Form.Item>
                  </Col>

                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      hasFeedback
                      label="Límite de días a importar ventas"
                    >
                      {getFieldDecorator('deadlineDaysForImportingSales', {
                        initialValue:
                          systemConfig.deadlineDaysForImportingSales,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un número de días.',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value <= 0) {
                                callback(
                                  'El número de días no puede ser negativo o cero.',
                                );
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(<InputNumber size="large" placeholder="Días" />)}
                    </Form.Item>
                  </Col>

                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 23, offset: 1 }}
                    xl={{ span: 23, offset: 1 }}
                    xxl={{ span: 23, offset: 1 }}
                  >
                    <Form.Item
                      label={'¿Usar credenciales para exportar ventas?'}
                    >
                      {getFieldDecorator('useG4scredentials', {
                        initialValue: settings.useG4scredentials,
                        valuePropName: 'checked',
                      })(
                        <Switch
                          onChange={(value) => {
                            settings.useG4scredentials = value;
                          }}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  {settings.useG4scredentials && (
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item hasFeedback label="Usuario">
                        {getFieldDecorator('g4sUser', {
                          initialValue: settings ? settings.g4sUser : '',
                          rules: [
                            {
                              required: true,
                              whitespace: true,
                              message: 'Ingresa tu credencial Usuario',
                            },
                            {
                              max: 100,
                              whitespace: true,
                              message: 'No se permiten mas de 100 caracteres',
                            },
                          ],
                        })(<Input size="large" placeholder="username" />)}
                      </Form.Item>
                    </Col>
                  )}
                  {settings.useG4scredentials && (
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item hasFeedback label="Contraseña">
                        {getFieldDecorator('g4sPassword', {
                          initialValue: settings ? settings.g4sPassword : '',
                          rules: [
                            {
                              required: true,
                              whitespace: true,
                              message: 'Ingrese su credencial contraseña',
                            },
                            {
                              max: 100,
                              whitespace: true,
                              message: 'No se permiten mas de 100 caracteres',
                            },
                          ],
                        })(
                          <Input.Password
                            prefix={<LockOutlined />}
                            size="large"
                            placeholder="password"
                            type="password"
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  )}
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>
                    Configuración de facturación
                  </h2>
                </Col>
                <Col span={14}>
                  <Row>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item label="El permiso CRE tiene como origen la venta">
                        {getFieldDecorator('isPermissionCreFromSale', {
                          initialValue: systemConfig.isPermissionCreFromSale,
                          valuePropName: 'checked',
                        })(<Switch />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Activar factura múltiple">
                      {getFieldDecorator('allowMultiple', {
                        initialValue: systemConfig.allowMultiple,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Activar facturación automática">
                      {getFieldDecorator('autoInvoice', {
                        initialValue: systemConfig.autoInvoice,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Cambiar tipo de pago">
                      {getFieldDecorator('changePayment', {
                        initialValue: systemConfig.changePayment,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Cambiar forma de pago">
                      {getFieldDecorator('changePaymentMethod', {
                        initialValue: systemConfig.changePaymentMethod,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Permitir al cliente seleccionar la forma de pago a Facturar">
                      {getFieldDecorator('assignPaymentCode', {
                        initialValue: settings.assignPaymentCode,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  {/* <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Usos de CFDI seleccionables para Facturar">
                      {getFieldDecorator('useCFDIS', {
                        initialValue: settings.useCFDIS.filter(item => item['active']===true).map(item=> item['code']),
                      })(
                        <Select showSearch size="large"  mode="multiple" maxTagCount={2} allowClear
                          onChange={(change)=>{
                            let arr = settings.useCFDIS.filter(item => item['active']===true).map(item=> item['code']);

                            console.log("QUE?", arr);
                            console.log("Change", change);
                          }}
                          >
                          {settings.useCFDIS.map((item: {code:string, description:string}): React.ReactNode=>(
                            <Select.Option key={item.code} value={item.code} title={item.code}>
                            <div id={item.code}>
                              {item.code.concat(" - ").concat(item.description)}
                            </div>
                        </Select.Option>
                        ))}
                      </Select>)}
                    </Form.Item>
                  </Col> */}
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Facturar créditos (como contado)">
                      {getFieldDecorator('invoiceCredit', {
                        initialValue: systemConfig.invoiceCredit,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Mostrar créditos">
                      {getFieldDecorator('showCredit', {
                        initialValue: systemConfig.showCredit,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Permitir cambio de clientes en ventas">
                      {getFieldDecorator('changeCustomer', {
                        initialValue: systemConfig.changeCustomer,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Activar reasignación de corte">
                      {getFieldDecorator('changeCut', {
                        initialValue: systemConfig.changeCut,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  {!systemConfig.isG4sSalesOrigin && (
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item
                        hasFeedback
                        label="Margen de diferencia para costeo"
                      >
                        {getFieldDecorator('costeoMargin', {
                          initialValue:
                            systemConfig.costeoMargin != null
                              ? systemConfig.costeoMargin
                              : 0,
                          rules: [
                            { required: true, message: 'Ingresa un margen' },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback('El valor no puede ser negativo');
                                } else {
                                  callback();
                                }
                              },
                            },
                          ],
                        })(
                          <InputNumber
                            size="large"
                            min={0}
                            step={0.01}
                            placeholder="Margen"
                            disabled={systemConfig.isG4sSalesOrigin}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  )}
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      hasFeedback
                      label="Conceptos maximos por factura"
                    >
                      {getFieldDecorator('maxConceptsNumber', {
                        initialValue: systemConfig.maxConceptsNumber,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un minimo de conceptos',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value < 0) {
                                callback('El valor no puede ser negativo');
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(<InputNumber size="large" placeholder="Conceptos" />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      label={
                        <>
                          Usar fecha de venta como fecha de factura
                          <Tooltip
                            placement="top"
                            title={`Asignar fecha de venta al campo 'Fecha de comprobante' solo para facturas con RFC genérico`}
                          >
                            <InfoCircleTwoTone style={{ fontSize: 16 }} />
                          </Tooltip>
                        </>
                      }
                    >
                      {getFieldDecorator('issueDateFromSale', {
                        initialValue: systemConfigInvoice.issueDateFromSale,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Forzar monto maximo a facturar (factura global)">
                      {getFieldDecorator('forceMaxAmountGlobalInvoice', {
                        initialValue: systemConfig.forceMaxAmountGlobalInvoice,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>
                    Configuración de plataforma
                  </h2>
                </Col>
                <Col span={14}>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Activar registro de clientes">
                      {getFieldDecorator('userRegister', {
                        initialValue: systemConfig.userRegister,
                        valuePropName: 'checked',
                      })(<Switch />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      help="RFC separado por coma"
                      label="RFC al que no se envían correos"
                    >
                      {getFieldDecorator('rfcEmailReject', {
                        initialValue: systemConfigInvoice.rfcEmailReject,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un minimo un RFC',
                          },
                        ],
                      })(<Input size="large" placeholder="RFC" />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 18, offset: 1 }}
                    xl={{ span: 18, offset: 1 }}
                    xxl={{ span: 18, offset: 1 }}
                  >
                    <Form.Item label="URL del Aviso de privacidad">
                      {getFieldDecorator('privacityUrl', {
                        initialValue:
                          settings.privacityUrl === ''
                            ? '#'
                            : settings.privacityUrl
                                .replace('http://', '')
                                .replace('https://', ''),
                        rules: [
                          {
                            required: true,
                            message: 'Escribe la url del aviso de privacidad',
                          },
                        ],
                      })(
                        <Input
                          size="large"
                          placeholder="URL"
                          addonBefore={selectBefore}
                          width="auto"
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Upload
                      name="bussisnesImage"
                      action="/"
                      accept=".jpg, .jpeg, .gif, .png"
                      listType="picture"
                      beforeUpload={this.handleBeforeUploadBusinessImage}
                      onRemove={this.handleRemoveBusinessImage}
                      showUploadList={{ showPreviewIcon: false }}
                    >
                      {this.state.businessImageFile.size <= 1
                        ? this.uploadButton(
                            isEmpty(systemConfig.businessImage)
                              ? 'Seleccionar Imagen de empresa'
                              : 'Cambiar Imagen',
                          )
                        : 'Imagen'}
                    </Upload>
                    <Col span={12}>
                      <h4>Imagen</h4>
                      {systemConfig.businessImage && (
                        <img
                          alt="Logo"
                          width="150"
                          src={
                            'data:image/jpg;base64,' +
                            systemConfig.businessImage
                          }
                        />
                      )}
                    </Col>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Upload
                      name="formatFile"
                      action="/"
                      accept=".jpg, .jpeg, .gif, .png"
                      listType="picture"
                      beforeUpload={this.handleBeforeUploadBusinessLogo}
                      onRemove={this.handleRemoveBusinessLogo}
                      showUploadList={{ showPreviewIcon: false }}
                    >
                      {this.state.businessLogoFile.size <= 1
                        ? this.uploadButton(
                            isEmpty(systemConfig.businessLogo)
                              ? 'Seleccionar Logo'
                              : 'Cambiar Logo',
                          )
                        : 'Logo'}
                    </Upload>
                    <Col span={12}>
                      <h4>Logo</h4>
                      {systemConfig.businessLogo && (
                        <img
                          alt="Logo"
                          width="150"
                          src={
                            'data:image/jpg;base64,' + systemConfig.businessLogo
                          }
                        />
                      )}
                    </Col>
                  </Col>
                </Col>
              </Row>
            </Card>

            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>
                    Configuración de sincronización estatus de cfdis al SAT
                  </h2>
                </Col>
                <Col span={14}>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      hasFeedback
                      label={
                        <>
                          Rango de actualización (días)
                          <Tooltip
                            placement="top"
                            title={`Se actualizará el estatus de las facturas realizadas en los últimos ${this.props.form.getFieldValue(
                              'satStsUpdFetchRangeDays',
                            )} días`}
                          >
                            <InfoCircleTwoTone style={{ fontSize: 16 }} />
                          </Tooltip>
                        </>
                      }
                    >
                      {getFieldDecorator('satStsUpdFetchRangeDays', {
                        initialValue:
                          systemConfigInvoice.satStsUpdFetchRangeDays,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un mínimo de días',
                          },
                        ],
                      })(
                        <InputNumber
                          size="large"
                          placeholder="Días"
                          min={1}
                          max={90}
                          step={1}
                          formatter={(value) =>
                            `${value}`.replace(/[^0-9]/g, '')
                          }
                          parser={(value) => parseInt(value || '0', 10)}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      hasFeedback
                      label={
                        <>
                          Periodo de sincronización (min)
                          <Tooltip
                            placement="top"
                            title={`Se ejecutará la tarea de actualización cada ${this.props.form.getFieldValue(
                              'satStsUpdIntervalMinutes',
                            )} minutos`}
                          >
                            <InfoCircleTwoTone style={{ fontSize: 16 }} />
                          </Tooltip>
                        </>
                      }
                    >
                      {getFieldDecorator('satStsUpdIntervalMinutes', {
                        initialValue:
                          systemConfigInvoice.satStsUpdIntervalMinutes,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un mínimo de minutos',
                          },
                          {
                            type: 'number',
                            min: 5,
                            max: 60,
                            message:
                              'Periodo de sincronización de estatus de cfdi no válido, por favor indique un número entre 5 y 60 minutos',
                          },
                        ],
                      })(
                        <InputNumber
                          size="large"
                          placeholder="Minutos"
                          type="number"
                          min={5}
                          max={60}
                          step={1}
                          formatter={(value) =>
                            `${value}`.replace(/[^0-9]/g, '')
                          }
                          parser={(value) => parseInt(value || '0', 10)}
                        />,
                      )}
                      <br></br>
                      <small>
                        *Esta configuración requiere reiniciar el servidor
                      </small>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      hasFeedback
                      label={
                        <>
                          Días sin actualización para considerar factura
                          <Tooltip
                            placement="top"
                            title={`Solo se actualizarán las facturas cuyo estatus no se haya actualizado en al menos ${this.props.form.getFieldValue(
                              'satStsUpdMinDaysBefore',
                            )} días`}
                          >
                            <InfoCircleTwoTone style={{ fontSize: 16 }} />
                          </Tooltip>
                        </>
                      }
                    >
                      {getFieldDecorator('satStsUpdMinDaysBefore', {
                        initialValue:
                          systemConfigInvoice.satStsUpdMinDaysBefore,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un mínimo de días',
                          },
                        ],
                      })(
                        <InputNumber
                          size="large"
                          placeholder="Días"
                          min={1}
                          max={30}
                          step={1}
                          formatter={(value) =>
                            `${value}`.replace(/[^0-9]/g, '')
                          }
                          parser={(value) => parseInt(value || '0', 10)}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>
                    Configuración de recuperación de ventas
                  </h2>
                </Col>
                <Col span={14}>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 18, offset: 1 }}
                    xl={{ span: 18, offset: 1 }}
                    xxl={{ span: 18, offset: 1 }}
                  >
                    <Form.Item label="Periodo en el cual se buscarán ventas/facturas 'perdidas' que no cumplieron su proceso de facturación">
                      {getFieldDecorator('timeoutPeriod', {
                        initialValue:
                          settings.timeOutSince !== ''
                            ? [
                                this.convertHourToPeriod(settings.timeOutLapse),
                                this.convertHourToPeriod(settings.timeOutSince),
                              ]
                            : [80, 90],
                        rules: [
                          {
                            required: true,
                            message:
                              'Debes establecer la periodicidad sobre la cual se buscarán ventas-facturas',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value[0] === value[1]) {
                                callback(
                                  'El valor incial y final del periodo no puede ser igual',
                                );
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(
                        <Slider
                          marks={marks}
                          step={10}
                          max={90}
                          tipFormatter={null}
                          range
                          included
                        />,
                      )}
                    </Form.Item>
                  </Col>

                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 18, offset: 1 }}
                    xl={{ span: 18, offset: 1 }}
                    xxl={{ span: 18, offset: 1 }}
                  >
                    <Form.Item label="Indica cada cuantos minutos se realizara la comprobación">
                      {getFieldDecorator('cronTimeout', {
                        initialValue: settings.timeOutCron,
                        rules: [
                          {
                            required: true,
                            message:
                              'Ingresa cada cuanto tiempo deseas se realice esta comprobación',
                          },
                          {
                            pattern: RegExp('^[0-9]*$'),
                            message: 'Solo puedes ingresar numero enteros',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value < 1 || value > 59) {
                                callback(
                                  'El valor debe estar entre 1 y 59 minutos',
                                );
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(
                        <InputNumber size="large" placeholder="Periodicidad" />,
                      )}
                      <br></br>
                      <small>
                        *Esta configuración requiere reiniciar el servidor
                      </small>
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
            </Card>

            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>
                    Configuración de archivo zip
                  </h2>
                </Col>
                <Col span={14}>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Seleccionar duración máxima del zip">
                      {getFieldDecorator('maxZipTime', {
                        initialValue: moment(
                          systemConfigInvoice.maxZipTimeHours +
                            ':' +
                            systemConfigInvoice.maxZipTimeMinutes,
                          'HH:mm',
                        ),
                        rules: [
                          {
                            required: true,
                            message: 'Debes establecer un mínimo de tiempo',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (
                                moment(value).hours() === 0 &&
                                moment(value).minutes() === 0
                              ) {
                                callback(
                                  'Debes establecer un mínimo de tiempo',
                                );
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(<TimePicker format="HH:mm" />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item
                      help="0 es sin limite"
                      label="Selecciona el tamaño máximo del zip en Mb"
                    >
                      {getFieldDecorator('maxZipSize', {
                        initialValue: systemConfigInvoice.maxZipSize,
                        rules: [
                          {
                            required: true,
                            message: 'Ingresa un valor para el tamaño del zip',
                          },
                          {
                            validator: (rule, value, callback) => {
                              if (value < 0) {
                                callback(
                                  'El valor no puede ser negativo para el tamaño del zip',
                                );
                              } else {
                                callback();
                              }
                            },
                          },
                        ],
                      })(
                        <InputNumber
                          about="holi"
                          size="large"
                          placeholder="tamaño"
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>Configuración de logs</h2>
                </Col>
                <Col span={14}>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <label>Borrar logs plataforma despues de</label>
                    <br />
                    <Col span={8}>
                      <Form.Item hasFeedback label="Años">
                        {getFieldDecorator('years', {
                          initialValue: years,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa un valor para los años',
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback(
                                    'El valor no puede ser negativo para los años',
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ],
                        })(<InputNumber size="small" placeholder="Años" />)}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item hasFeedback label="Meses">
                        {getFieldDecorator('months', {
                          initialValue: months,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa un valor para los meses',
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback(
                                    'El valor no puede ser negativo para los meses',
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ],
                        })(<InputNumber size="small" placeholder="Meses" />)}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item hasFeedback label="Días">
                        {getFieldDecorator('days', {
                          initialValue: days,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa un valor para los días',
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback(
                                    'El valor no puede ser negativo para los días',
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ],
                        })(<InputNumber size="small" placeholder="Días" />)}
                      </Form.Item>
                    </Col>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <label>Borrar logs facturacion despues de</label>
                    <br />
                    <Col span={8}>
                      <Form.Item hasFeedback label="Años">
                        {getFieldDecorator('yearsInvoice', {
                          initialValue: yearsInvoice,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa un valor para los años',
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback(
                                    'El valor no puede ser negativo para los años',
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ],
                        })(<InputNumber size="small" placeholder="Años" />)}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item hasFeedback label="Meses">
                        {getFieldDecorator('monthsInvoice', {
                          initialValue: monthsInvoice,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa un valor para los meses',
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback(
                                    'El valor no puede ser negativo para los meses',
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ],
                        })(<InputNumber size="small" placeholder="Meses" />)}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item hasFeedback label="Días">
                        {getFieldDecorator('daysInvoice', {
                          initialValue: daysInvoice,
                          rules: [
                            {
                              required: true,
                              message: 'Ingresa un valor para los días',
                            },
                            {
                              validator: (rule, value, callback) => {
                                if (value < 0) {
                                  callback(
                                    'El valor no puede ser negativo para los días',
                                  );
                                } else {
                                  callback();
                                }
                              },
                            },
                          ],
                        })(<InputNumber size="small" placeholder="Días" />)}
                      </Form.Item>
                    </Col>
                  </Col>
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Row>
                <Col span={10}>
                  <h2 style={{ color: '#296FC4' }}>
                    Configuración de correo al cliente
                  </h2>
                </Col>
                <Col span={14}>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Email de atención a cliente">
                      {getFieldDecorator('emailContact', {
                        initialValue: systemConfigInvoice.emailContact,
                      })(<Input size="large" placeholder="Email" />)}
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 23, offset: 1 }}
                    sm={{ span: 23, offset: 1 }}
                    md={{ span: 23, offset: 1 }}
                    lg={{ span: 11, offset: 1 }}
                    xl={{ span: 11, offset: 1 }}
                    xxl={{ span: 11, offset: 1 }}
                  >
                    <Form.Item label="Sitio web de atención a cliente">
                      {getFieldDecorator('siteContact', {
                        initialValue: systemConfigInvoice.siteContact,
                      })(<Input size="large" placeholder="Sitio Web" />)}
                    </Form.Item>
                  </Col>
                </Col>
              </Row>
            </Card>
            <Card className={'customer-card'}>
              <Collapse bordered={false}>
                <Panel
                  forceRender
                  key="smtp"
                  header={
                    <h2 style={{ color: '#296FC4', marginBottom: 0 }}>
                      Configuración del servidor de correo (SMTP)
                    </h2>
                  }
                >
                  <Row>
                    <Col span={24}>
                      <p>
                        Opcional. Si se capturan, estas credenciales tienen
                        prioridad sobre las del archivo de configuración de la
                        aplicación y deben pasar la prueba del botón Test para
                        poder guardarse.
                      </p>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      lg={{ span: 7, offset: 1 }}
                      xl={{ span: 7, offset: 1 }}
                      xxl={{ span: 7, offset: 1 }}
                    >
                      <Form.Item label="Usar estas credenciales">
                        {getFieldDecorator('smtpEnabled', {
                          valuePropName: 'checked',
                          initialValue: smtpSettings.enabled,
                        })(<Switch onChange={this.handleSmtpFieldChange} />)}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      lg={{ span: 9, offset: 1 }}
                      xl={{ span: 9, offset: 1 }}
                      xxl={{ span: 9, offset: 1 }}
                    >
                      <Form.Item label="Servidor (host)">
                        {getFieldDecorator('smtpHost', {
                          initialValue: smtpSettings.host,
                        })(
                          <Input
                            size="large"
                            placeholder="smtp.miservidor.mx"
                            onChange={this.handleSmtpFieldChange}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      lg={{ span: 4, offset: 1 }}
                      xl={{ span: 4, offset: 1 }}
                      xxl={{ span: 4, offset: 1 }}
                    >
                      <Form.Item label="Puerto">
                        {getFieldDecorator('smtpPort', {
                          initialValue: smtpSettings.port,
                        })(
                          <InputNumber
                            size="large"
                            min={1}
                            max={65535}
                            placeholder="587"
                            onChange={this.handleSmtpFieldChange}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item label="Usuario">
                        {getFieldDecorator('smtpUsername', {
                          initialValue: smtpSettings.username,
                        })(
                          <Input
                            size="large"
                            placeholder="Usuario SMTP"
                            onChange={this.handleSmtpFieldChange}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item label="Contraseña">
                        {getFieldDecorator('smtpPassword', {
                          initialValue: smtpSettings.password,
                        })(
                          <Input.Password
                            size="large"
                            prefix={<LockOutlined />}
                            placeholder="Contraseña SMTP"
                            onChange={this.handleSmtpFieldChange}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item
                        label={
                          <span>
                            Remitente (mail.from){' '}
                            <Tooltip title="Correo que aparece como remitente. Solo es necesario cuando el servicio SMTP lo exige porque el usuario SMTP no es un correo sender. Si se deja vacío se usa el usuario SMTP.">
                              <InfoCircleTwoTone />
                            </Tooltip>
                          </span>
                        }
                      >
                        {getFieldDecorator('smtpFrom', {
                          initialValue: smtpSettings.from,
                        })(
                          <Input
                            size="large"
                            placeholder="mail@mail.mx"
                            onChange={this.handleSmtpFieldChange}
                          />,
                        )}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 11, offset: 1 }}
                      lg={{ span: 11, offset: 1 }}
                      xl={{ span: 11, offset: 1 }}
                      xxl={{ span: 11, offset: 1 }}
                    >
                      <Form.Item
                        label={
                          <span>
                            Destinatario de la prueba{' '}
                            <Tooltip title="Correo al que se envía el mensaje de prueba. Si se deja vacío se envía al propio remitente.">
                              <InfoCircleTwoTone />
                            </Tooltip>
                          </span>
                        }
                      >
                        {getFieldDecorator('smtpTestRecipient', {
                          initialValue: '',
                        })(<Input size="large" placeholder="prueba@mail.mx" />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 7, offset: 1 }}
                      lg={{ span: 7, offset: 1 }}
                      xl={{ span: 7, offset: 1 }}
                      xxl={{ span: 7, offset: 1 }}
                    >
                      <Form.Item label="Requiere autenticación">
                        {getFieldDecorator('smtpAuth', {
                          valuePropName: 'checked',
                          initialValue: smtpSettings.auth,
                        })(<Switch onChange={this.handleSmtpFieldChange} />)}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 7, offset: 1 }}
                      lg={{ span: 7, offset: 1 }}
                      xl={{ span: 7, offset: 1 }}
                      xxl={{ span: 7, offset: 1 }}
                    >
                      <Form.Item label="STARTTLS">
                        {getFieldDecorator('smtpStartTls', {
                          valuePropName: 'checked',
                          initialValue: smtpSettings.startTls,
                        })(<Switch onChange={this.handleSmtpFieldChange} />)}
                      </Form.Item>
                    </Col>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 6, offset: 1 }}
                      lg={{ span: 6, offset: 1 }}
                      xl={{ span: 6, offset: 1 }}
                      xxl={{ span: 6, offset: 1 }}
                    >
                      <Form.Item label="SSL">
                        {getFieldDecorator('smtpSslEnable', {
                          valuePropName: 'checked',
                          initialValue: smtpSettings.sslEnable,
                        })(<Switch onChange={this.handleSmtpFieldChange} />)}
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={{ span: 23, offset: 1 }}
                      sm={{ span: 23, offset: 1 }}
                      md={{ span: 23, offset: 1 }}
                      lg={{ span: 23, offset: 1 }}
                      xl={{ span: 23, offset: 1 }}
                      xxl={{ span: 23, offset: 1 }}
                    >
                      <Button
                        type="primary"
                        ghost
                        loading={this.state.smtpTesting}
                        onClick={this.handleTestSmtp}
                      >
                        {this.state.smtpTested && (
                          <CheckCircleFilled style={{ color: '#52c41a' }} />
                        )}
                        {this.state.smtpTesting ? 'Probando...' : 'Test'}
                      </Button>
                      {this.state.smtpTestMessage !== '' && (
                        <Text
                          style={{
                            marginLeft: '1rem',
                            color: this.state.smtpTested ? '#52c41a' : 'red',
                          }}
                        >
                          {this.state.smtpTestMessage}
                        </Text>
                      )}
                    </Col>
                  </Row>
                </Panel>
              </Collapse>
            </Card>
            <Card className={'customer-card'}>
              <Col span={5} offset={19}>
                <Button
                  className="button-customer-serch-style"
                  block
                  size="large"
                  type="primary"
                  onClick={() =>
                    this.setState({ configModal: !this.state.configModal })
                  }
                >
                  {isFetching ? 'Cargando...' : 'Modificar configuración'}
                </Button>
              </Col>
            </Card>
          </Form>
        </Card>
      </Spin>
    );
  };
}

const mapStateToProps = (states: RootState): StateProps => {
  return {
    isFetching: states.configurationState.isFetching,
    days: states.configurationState.days,
    months: states.configurationState.months,
    years: states.configurationState.years,
    daysInvoice: states.configurationState.daysInvoice,
    monthsInvoice: states.configurationState.monthsInvoice,
    yearsInvoice: states.configurationState.yearsInvoice,
    systemConfig: states.configurationState.systemConfig,
    systemConfigInvoice: states.configurationState.systemConfigInvoice,
    settings: states.configurationState.settings,
    smtpSettings: states.configurationState.smtpSettings,
  };
};

const mapDispatchToProps = {
  getDayToDelete,
  getMonthToDelete,
  getYearToDelete,
  getDayToDeleteInvoice,
  getMonthToDeleteInvoice,
  getYearToDeleteInvoice,
  getSystemConfig,
  getSystemConfigInvoice,
  getSystemSettings,
  getSmtpSettings,
  saveNewConfigurations,
};

export default connect<
  StateProps,
  DispatchProps,
  Record<string, unknown>,
  RootState
>(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(Configuration));
